import { useEffect, useState } from 'react';
import { isWregDesktopViewport, WREG_DESKTOP_QUERY as QUERY } from '@/utils/viewport';

export { WREG_DESKTOP_MIN_WIDTH_PX } from '@/utils/viewport';

const useWregDesktop = (): boolean => {
  const [isDesktop, setIsDesktop] = useState<boolean>(isWregDesktopViewport);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(QUERY);
    const onChange = () => setIsDesktop(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isDesktop;
};

export { useWregDesktop };
